export const BaudRate = {
  "115200": "250000",
  "250000": "115200",
};
